import arnaudImg from '@/assets/team/arnaud.webp';
import kerimImg from '@/assets/team/kerim.webp';
import gabrielImg from '@/assets/team/gabriel.webp';
import omarImg from '@/assets/team/omar.webp';
import andreiImg from '@/assets/team/andrei.webp';
import jacksonImg from '@/assets/team/jackson.webp';
import marisolImg from '@/assets/team/marisol.webp';
import danielaImg from '@/assets/team/daniela.webp';


export const teamLeaders = [
  {
    name: "Arno ADORNIER",
    role: "Chief Executive Officer",
    description: "Client Relationship & Customer Success Management",
    highlight: "Bachelor, majoring in physics • 9+ years in marketing",
    image: arnaudImg,
    contactUrl: "/aa",
    instagram: "https://instagram.com/arno.adornier",
    instagramHandle: "@arno.adornier"
  },
  {
    name: "Kerim JAKUPOVIC",
    role: "COO & Strategist",
    description: "Advertising Strategy, Project Management & Technical Implementation",
    highlight: "Master's in Marketing • 4+ years in ad production",
    image: kerimImg,
    contactUrl: "/kj",
    instagram: "",
    instagramHandle: ""
  }
];

export const teamMembers = [
  {
    name: "Gabriel AGERON",
    role: "Website & Web Apps Developer / Media Buyer",
    description: "Web development, application engineering, and media buying",
    highlight: "Expert in modern web technologies",
    image: gabrielImg
  },
  {
    name: "Omar TROUSSI",
    role: "Advertising Manager / Media Buyer",
    description: "Advertising Campaigns Management",
    highlight: "4+ years of advertising campaigns management",
    image: omarImg
  },
  {
    name: "Andrei ADAVANII",
    role: "Video Editor",
    description: "Ad Assembly and Post-Production",
    highlight: "6+ years of video editing experience",
    image: andreiImg
  },
  {
    name: "Jackson WILLHOIT",
    role: "Videographer",
    description: "Camera work, equipment, lighting, and filming for every shoot.",
    highlight: "Bachelor's degree in Video Production • 9+ years of professional video production",
    image: jacksonImg
  },
  {
    name: "Daniela CASTRO",
    role: "Production Coordinator & Actress",
    description: "Coordinates shoot logistics, talent and scheduling, and appears on camera for client productions.",
    highlight: "Bilingual (English / Spanish) • On-set coordination and on-camera talent",
    image: marisolImg
  },
  {
    name: "Marisol GUZMANN",
    role: "Production Coordinator & Actress",
    description: "Coordinates shoot logistics, talent and scheduling, and appears on camera for client productions.",
    highlight: "Bilingual (English / Spanish) • On-set coordination and on-camera talent",
    image: danielaImg
  }
];

